import React from 'react';
import { getContext } from '@fiverr-private/fiverr_context';
import { localStorage } from '@fiverr-private/futile';
import { kebabCase } from 'lodash';
import { ViewsCounter } from '../../../utils/common/views-counter';

const LOCAL_STORAGE_CLOSE_KEY = 'hide_fib_col_st';
const LOCAL_STORAGE_VIEW_TOTAL_COUNT_KEY = 'fib_col_st_view_total_count';
const LOCAL_STORAGE_VIEW_PERIOD_COUNT_KEY = 'fib_col_st_view_period_count';
const USER_VIEW_TOTAL_COUNT_MAX = 6;
const USER_VIEW_PERIOD_COUNT_MAX = 1;
const PERIOD_COUNTER_TTL = 86400000; // 1 day

const userKey = (key) => {
    const { userId } = getContext();
    return `${kebabCase(key)}-${userId}`;
}

export const hideStepper = () => localStorage.set(userKey(LOCAL_STORAGE_CLOSE_KEY), '1');

export const shouldHideStepper = () =>
    !!localStorage.get(userKey(LOCAL_STORAGE_CLOSE_KEY)) ||
    periodViewsCounter().reached(USER_VIEW_PERIOD_COUNT_MAX) ||
    totalViewsCounter().reached(USER_VIEW_TOTAL_COUNT_MAX);

export const addStepperViews = () => [periodViewsCounter(), totalViewsCounter()].forEach(counter => counter.addView());

const totalViewsCounter = () => ViewsCounter.getOrInit(userKey(LOCAL_STORAGE_VIEW_TOTAL_COUNT_KEY));
const periodViewsCounter = () => ViewsCounter.getOrInit(userKey(LOCAL_STORAGE_VIEW_PERIOD_COUNT_KEY), PERIOD_COUNTER_TTL);
